import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetUserSubServicesDataTypes } from "../../../Schema/getUserSubServices.types";
import { useAppDispatch, useAppSelector } from "../../../Hooks/useStore";
import { useCallback } from "react";

export type InitialStateTypes = {
  activeSubService: GetUserSubServicesDataTypes | null;
};

const initialState = {
  activeSubService: null,
  fetchedSubServices: [],
} as InitialStateTypes;

export const activeSubServiceSlice = createSlice({
  name: "activeSubServiceSlice",
  initialState,
  reducers: {
    setActiveSubService: (
      state,
      action: PayloadAction<GetUserSubServicesDataTypes>,
    ) => {
      state.activeSubService = action.payload;
    },
    resetActiveSubService: (state) => {
      state.activeSubService = null;
    },
  },
});

export const useActiveSubService = () => {
  const { activeSubService } = useAppSelector(
    (state) => state.activeSubService,
  );
  const dispatch = useAppDispatch();

  const dispatchSetActiveSubService = useCallback(
    (data: GetUserSubServicesDataTypes) => {
      dispatch(setActiveSubService(data));
    },
    [dispatch],
  );

  return {
    activeSubService,
    dispatchSetActiveSubService,
  };
};

export const { setActiveSubService, resetActiveSubService } =
  activeSubServiceSlice.actions || {};
export default activeSubServiceSlice.reducer;
